import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

export default () => {
	domContentLoaded(() => {
		const { body } = document;
		const navTriggers = document.querySelectorAll('.js-menu-trigger');
		const navContents = document.querySelector('.js-menu');
		let sc;
		navTriggers.forEach((navTrigger) => {
			navTrigger.addEventListener('click', () => {
				const flag = navContents.classList.contains('is-opened');
				if (flag) {
					body.classList.remove('is-locked');
					window.scrollTo(0, sc);
					body.style.top = '';
					navContents.classList.remove('is-opened');
					navContents.classList.add('is-closed');
				} else {
					sc = Math.trunc(window.pageYOffset);
					body.style.top = `${sc * -1}px`;
					body.classList.add('is-locked');
					navContents.classList.remove('is-closed');
					navContents.classList.add('is-opened');
				}
			});
		});
	});
	window.addEventListener('resize', throttle(200, () => {
		if (window.innerWidth >= 1024 && document.body.classList.contains('is-locked')) {
			document.body.classList.remove('is-locked');
			window.scrollTo(0, 0);
			document.body.style.top = '';
			document.querySelector('.js-menu').classList.remove('is-opened');
			document.querySelector('.js-menu').classList.add('is-closed');
		}
	}), false);
};
